import { Document, RelatedDocument, RelatedDocumentCountsByDataset } from 'src/app/modules/core/store/models/document.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { Layer } from '../cop/models';
import { View } from 'src/app/modules/core/store/models';
import { CameraWithMediaDto } from 'src/app/modules/core/store/models/camera-with-media.model';

export interface RsdState {
  selectedDocumentStack: SelectedDocumentState[];
  ui: {
    isDrawerOpen: boolean;
    isEdit: boolean;
    isNew: boolean;
  };

  // related docs
  relatedDatasets: Dataset[];
//  relatedDocuments: RelatedDocument[];
  relatedDocumentCountsByDataset: RelatedDocumentCountsByDataset[];
  newRelatedDocument?: Document;
  vmsCameraMedia?: { [key: string]: CameraWithMediaDto[] };
}

export interface SelectedDocumentState {
  layer?: Layer;
  dataset: Dataset;
  document: Document;
  editView: View;
  backAction?: string;
  translatedFrom?: string;
  translatedTo?: string;
}
export enum AlertSeverity {
  Unknown = 0,
  Minimal = 1,
  Low = 2, 
  Moderate = 3,
  High = 4,
  Extreme = 5 
}
